module.exports = __webpack_public_path__ + "img/kiosk.46536faa.png";